import { faBasketShopping, faLocationPin } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { twMerge } from 'tailwind-merge';

interface LocationCustomPinProps {
  title?: string;
  icon?: IconDefinition;
  classes_marker?: string;
  classes_marker_base?: string;
  classes_marker_shadow?: string;
  classes_marker_icon?: string;
  classes_marker_icon_section?: string;
  classes_marker_title?: string;
}

export const LocationCustomPin = ({
  title,
  icon = faBasketShopping,
  classes_marker,
  classes_marker_base,
  classes_marker_shadow,
  classes_marker_icon,
  classes_marker_icon_section,
  classes_marker_title,
}: LocationCustomPinProps) => {
  return (
    <div className={twMerge('relative', classes_marker_base)}>
      {/* Marker Shadow */}
      <FontAwesomeIcon
        icon={faLocationPin}
        className={twMerge(
          'w-20 h-12 text-black leading-none absolute -left-0.5 top-0.5 opacity-50',
          classes_marker_shadow,
        )}
      />
      {/* Marker */}
      <FontAwesomeIcon
        icon={faLocationPin}
        className={twMerge('w-20 h-12 text-white leading-none relative', classes_marker)}
      />
      {/* Marker Icon */}
      <div
        className={twMerge(
          'absolute top-1 left-1/2 -translate-x-1/2 bg-[#EA4236] p-1.5 rounded-full',
          classes_marker_icon_section,
        )}
      >
        <FontAwesomeIcon icon={icon} className={twMerge('w-4 h-4 text-white leading-none', classes_marker_icon)} />
      </div>
      {/* Marker Text */}
      {title && (
        <div
          className={twMerge(
            'absolute top-1/2 right-16 -translate-y-1/2 min-w-[100px] text-center text-black-500 font-semibold bg-white bg-opacity-70 p-1 rounded-md shadow-md',
            classes_marker_title,
          )}
        >
          {title}
        </div>
      )}
    </div>
  );
};
